export class SecretVerificationRequest {
  masterPasswordHash: string;
  otp: string;
}
